import { data as shardaData } from './shardaLandingPageData';
const activities1 = '/images/co-branded-images/activities1.png';
const activities2 = '/images/co-branded-images/activities2.png';
const activities3 = '/images/co-branded-images/activities3.png';
const activities4 = 'https://masai-website-images.s3.ap-south-1.amazonaws.com/quizzess_41cf53d0fb.png';
const conductingNegotiationsBoardroom = '/images/co-branded-images/conducting-negotiations-boardroom.png';

export const data = {
	...shardaData,
	logo: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/sharda_university_logo_B07701_EADE_seeklogo_com_bf13856c77.png',
	UnlockingOpportunities: {
		order: 1,
		title: 'Unlocking Opportunities',
		text: 'Empowering Students to Upskill and Secure Jobs Through Practical Experience',
		bannerImage: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/sharda_university_greater_noida_62059cbc01.jpg',
	},
	knowYourLevel: {
		order: 2,
		text: 'Know Your Level',
		description: 'Take the KYL Assessment to discover where you stand.',
	},
	prepleafElite: {
		order: 3,
		heading: 'We have something more for you!',
		title: 'Prepleaf Elite Program',
		points: [
			{
				text: 'Receive 2 months of intensive, free training designed to enhance your skills and readiness for the professional world.',
				highlight: '',
			},
			{ text: 'Stand a chance to unlock your dream job with a package of 10 LPA+', highlight: '10 LPA+' },
		],
	},
	companiesMarqueeData: {
		...shardaData.companiesMarqueeData,
		title: '4000+ Companies are hiring',
		order: 4,
	},
	learningPotential: {
		heading: 'Resources to help you upskill',
		order: 5,
		data: [
			{
				text: 'Masterclass',
				data: {
					text: 'Masterclass',
					image: activities2,
					points: [
						'Unlock your true potential with personalized mentorship and powerful learning experiences. Gain insights from industry pros through inspiring lectures and skill-building sessions. Dive into masterclasses, workshops, and bootcamps that supercharge your academic and career growth.',
					],
				},
			},
			{
				text: 'Practise Contests & Quizzes',
				data: {
					text: 'Practise Contests & Quizzes',
					image: activities4,
					points: [
						'Join the quest for knowledge and excellence in our quizzes and contests section. Test your abilities, learn, and triumph in an environment designed to push your limits.',
					],
					action: { href: '/sign-in', text: 'START PRACTISING', action: 'link', variant: 'primary', newTab: false },
				},
			},
			{
				text: 'Community',
				data: {
					text: 'Community',
					image: activities3,
					points: [
						'Join our vibrant community that encourages innovation and teamwork. Dive into limitless opportunities with entrepreneurship, programming, and tech enthusiasts’ clubs. Interact with like-minded people in networking events and project expos and build meaningful friendships and bonds that’ll help you in your career.',
					],
					action: { href: 'https://telegram.me/masaitribe', text: 'Join Community', action: 'link', variant: 'primary', newTab: true },
				},
			},
			{
				text: 'Resume Builder',
				data: {
					text: 'Resume Builder',
					image: activities1,
					points: [
						'Craft your future with a professional edge. Build your resume on our platform by adding your educational achievements and personal details, creating a strong foundation for your career.',
					],
					// action: { href: '/resume', text: 'start building', action: 'link', variant: 'primary', newTab: false },
				},
			},
			{
				text: 'Career Counselling',
				data: {
					text: 'Career Counselling',
					image: conductingNegotiationsBoardroom,
					points: [
						'Experience personalized career counseling with our experts. One-stop solution connecting you with your future. We help you lay the foundations for your career, from skill development to how to find a job. You’ll understand yourself and the job market much better - getting you exponentially closer to your desired career.',
					],
					action: { action: 'book-slot', text: 'Book Now For Free', variant: 'primary' },
				},
			},
		],
	},
	gatewayToDreamCareer: {
		order: 4,
		heading: 'Your Gateway to your dream career',
		steps: [
			{
				image: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/check_tv_b567325cbc.png',
				text: 'Take the KYL Test',
				description: 'Take the first assessment to know where you stand',
			},
			{
				image: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/book_e0531ec9ce.png',
				text: 'Practise to Upskill',
				description: 'View Masterclasses, take practise contests and quizzes & more.',
			},
			{
				image: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/job_tv_aed239c157.png',
				text: 'Apply to Jobs',
				description: 'Use badges to unlock companies that you earn',
			},
		],
	},
	results: {
		order: 6,
		topHeading: '',
		centerHeading: 'Real Returns in Real Time',
		bottomHeading: '',
		data: [
			{
				heading: '4,000+',
				text: 'Companies Hiring',
			},
			{
				heading: '6.9 LPA',
				text: 'Average CTC',
			},
			{
				heading: '1,000+',
				text: 'Country wide participants',
			},
		],
	},
	faq: {
		order: 8,
		title: 'Frequently Asked Questions',
		faqs: [
			{
				question: 'What is the Prepleaf Elite Program?',
				answer:
					'It is a Program that will be offered to a select few students who perform really well in the Know Your Level Assessment. The team will reach out to you with more information in case you are eligible.',
				questionType: 'co-branded',
			},
			{
				question: 'What are badges and how can I earn them?',
				answer:
					'Badges are awarded to students based on their performance in the time quiz available in every section. There are 5 sections - Aptitude, CS Fundamentals, DSA Basic, DSA Fundamentals & Explore Your Project. There is 1 badge for each section that can be earned.',
				questionType: 'co-branded',
			},
			{
				question: 'How can I apply for jobs?',
				answer:
					'Applying to jobs requires you to earn certain badges and get a certain percentile score from the Know Your Level Test. The eligibility criteria to apply can be seen for each company.',
				questionType: 'co-branded',
			},
			{
				question: 'Can I take the Quizzes, Contests, Know Your Level Test again, after the first attempt? ',
				answer: `There may be a chance that we can unlock the activities after a certain number of days. In such cases, we will reach out to you and let you know.`,
				questionType: 'co-branded',
			},
			{
				question: 'What are streaks?',
				answer: `Streaks define the completion of any activity in a day. If you have completed any activity, you add to your streak. On reaching the 7th, 14th, 21st…. Day, you can even share your streaks on social media to make your friends jealous!`,
				questionType: 'co-branded',
			},
		],
	},
};
